import { createContext, useContext, type ReactNode } from 'react'

const ReleaseContext = createContext({
  current: null as string | null,
  behind: null as string | null,
})

/** What the account menu and Me draw. Null until a production server answers. */
export function useAppVersion(): { current: string | null; behind: string | null } {
  return useContext(ReleaseContext)
}

export function AppVersionProvider({
  current,
  behind,
  children,
}: {
  current: string | null
  behind: string | null
  children: ReactNode
}) {
  return <ReleaseContext.Provider value={{ current, behind }}>{children}</ReleaseContext.Provider>
}
